import { useCallback, useSyncExternalStore } from "react";

import type { SlideSetting } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";

/** 1 枚のスライド設定を購読する。無ければ undefined。 */
export function useSlide(slideId: string): SlideSetting | undefined {
    const subscribe = useCallback(
        (cb: () => void) => generationSettingStore.subscribeSlide(slideId, cb),
        [slideId]
    );
    const getSnapshot = useCallback(() => generationSettingStore.getSlide(slideId), [slideId]);
    return useSyncExternalStore(subscribe, getSnapshot);
}
